module.exports = __webpack_public_path__ + "img/B-active.2a0a0e7f.png";